import intiLogo from "../img/LOGO INTI 2.jpeg";
import intiLogo2 from "../img/LOGO INTI.jpeg";
import matesSlider from "../img/matesSlider.jpeg";
import IntiVideo from "../img/IntiVideo.mp4"

const slider = [
    {
        id:1,
        image:intiLogo,
        title:"foto"
    },
    {
        id:2,
        image:intiLogo2,
        title:"foto"
    },
    {
        id:3,
        image:matesSlider,
        title:"foto"
    },
    {
        id:4,
        image: IntiVideo,
        title:"video"
    }
]

export default slider;